var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{staticClass:"abc",attrs:{"left":"","bottom":"","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"ml-2"},on),[_c('img',{staticClass:"flagIcon",attrs:{"src":_vm.flagIcon,"alt":"flag"}})])]}}])},[_c('Translator',{attrs:{"countries":_vm.countries},on:{"on-country-click":_vm.changeFlag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }